import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { satoshi500 } from "../../../../styles/font.constants";

export const EditContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const Textarea = styled.textarea`
	${satoshi500}
	width: 100%;
	min-height: 4rem;
	padding: 0.5rem;
	border-radius: 0.5rem;
	border: solid 1px ${colours.greyDark};
	color: ${colours.greyDarker};
	resize: none;
	line-height: 130%;

	&:focus {
		outline: none;
		border-color: ${colours.greyDarker};
	}
`;

export const ButtonRow = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 0.5rem;
	margin-bottom: 0.5rem;
`;
